import { createValidation } from '../../utils/validation';
import depositorConfig from './depositorConfig';

// Create validation factory for Depositor entity
const createDepositorValidation = () => {
  return createValidation(depositorConfig.fields);
};

// Export both the factory and a default instance
export const validateDepositorData = createDepositorValidation();
export const createDepositorValidationSchema = createDepositorValidation;
export default createDepositorValidation;

